import {
  Button,
  FoundationColorTokens,
  Plus,
  Spacing,
  Typography,
} from "@surya-digital/leo-reactjs-material-ui";
import { TFunction } from "i18next";
import React, { useState } from "react";
import { AddMultipleSPoCsDialog } from "./AddMultipleSPoCsDialog";
import { Instance } from "mobx-state-tree";
import { AddMultipleSPoCsStore } from "../../store/AddMultipleSPoCsStore";
import { NavigateToFunctions } from "../../../../routes/RoutesHelper";

interface AddMultipleSPoCsProps {
  t: TFunction;
  addMultipleSPoCsStore: Instance<typeof AddMultipleSPoCsStore>;
  navigateTo: NavigateToFunctions;
  spacing: Spacing;
  tokens: FoundationColorTokens<string>;
  typography: Typography;
  onClose: () => Promise<void>;
}

export const AddMultipleSPoCs = ({
  t,
  addMultipleSPoCsStore,
  navigateTo,
  spacing,
  tokens,
  typography,
  onClose,
}: AddMultipleSPoCsProps): React.ReactElement => {
  const [isAddMultipleSPoCsDialogOpen, setIsAddMultipleSPoCsDialogOpen] =
    useState(false);
  return (
    <>
      <Button
        icon={<Plus />}
        iconPosition="leading"
        label={t("projects.userAccess.addMultipleSPoCs.buttonText")}
        name={t("projects.userAccess.addMultipleSPoCs.buttonText")}
        variant="outlined-color"
        size="medium"
        onClick={(): void => {
          setIsAddMultipleSPoCsDialogOpen(true);
        }}
      />
      {isAddMultipleSPoCsDialogOpen && (
        <AddMultipleSPoCsDialog
          isAddMultipleSPoCsDialogOpen={isAddMultipleSPoCsDialogOpen}
          setIsAddMultipleSPoCsDialogOpen={setIsAddMultipleSPoCsDialogOpen}
          t={t}
          addMultipleSPoCsStore={addMultipleSPoCsStore}
          navigateTo={navigateTo}
          spacing={spacing}
          tokens={tokens}
          typography={typography}
          onClose={onClose}
        />
      )}
    </>
  );
};
